import { connect } from 'react-redux';
import { frontloadConnect } from 'react-frontload';
import { Dispatch } from 'redux';
import { parse } from 'query-string';
import { getSearch } from 'connected-react-router';
import { PageProductCalendar, Props } from 'components/pages/PageProductCalendar/PageProductCalendar';
import { getProductAggsPageContent } from 'modules/content/actions';
import {
  fetchCalendarSearchContent,
  fetchPromotionalBannerProduct,
  resetSearchModule,
  resetSkipSearchFrontloadRequest,
} from 'modules/search';
import { productAggPageContentSelector } from 'modules/content/selectors';
import {
  paginationSelector,
  searchResultsSelector,
  searchResultsLoadingSelector,
  searchResultsFetchedSelector,
  skipSearchFrontloadRequestSelector,
  searchPromotionalBannerProductSelector,
} from 'modules/search/selectors';
import { isAuthSelector } from 'modules/user/selectors';
import { DefaultPagination, productAggsPageTitles } from 'constants/index';
import { productTypeCalendarSelector } from 'modules/productTypes/selectors';
import { getWebcastPass } from 'modules/products/actions';
import { Product } from 'mxp-schemas';

const mapActionCreators = (dispatch: Dispatch) => ({
  async fetchCalendarSearchContent(): Promise<void> {
    const webcastPassSlug = 'annual-webcast-pass';
    await dispatch(
      getProductAggsPageContent({
        isAggByTopicPage: false,
        topicSlug: '',
        productTypeSlug: Product.ProductSlug.CALENDAR,
      })
    );
    await dispatch(fetchPromotionalBannerProduct(webcastPassSlug));
    await dispatch(fetchCalendarSearchContent());
    await dispatch(getWebcastPass());
  },
  resetSearchModule(): void {
    dispatch(resetSearchModule());
  },
  resetSkipSearchFrontloadRequest(): void {
    dispatch(resetSkipSearchFrontloadRequest());
  },
});

const mapStateToProps = (state: State.Root) => {
  const search = getSearch(state);
  const {
    sortBy = DefaultPagination.Grid.SORT_BY,
    page = DefaultPagination.Grid.PAGE,
    perPage = DefaultPagination.Grid.MIN_PER_PAGE,
    date,
    topic,
    subtopic,
    category,
    type,
    premium,
    credits,
    getNoticed,
    includedInWebcastPass,
    nasbaField,
    nasbaProgram,
    availableFormat,
    eventStartDate,
    eventEndDate,
  }: any = parse(search, {
    arrayFormat: 'comma',
    parseNumbers: true,
  });
  const cpeCredits: string[] = credits === 0 ? credits.toString() : credits;
  const filtersStr: string = [
    date,
    topic,
    subtopic,
    category,
    type,
    premium,
    cpeCredits,
    getNoticed,
    includedInWebcastPass,
    nasbaField,
    nasbaProgram,
    availableFormat,
    eventStartDate,
    eventEndDate,
  ]
    .filter(Boolean)
    .join();

  const pageTitle = productAggsPageTitles[type] || '';

  return {
    isAuth: isAuthSelector(state),
    sortBy,
    page,
    perPage,
    filtersStr, // subscription required to fire fetchSearchContent if changed
    pagination: paginationSelector(state),
    resultsLoading: searchResultsLoadingSelector(state),
    resultsFetched: searchResultsFetchedSelector(state),
    results: searchResultsSelector(state),
    productType: productTypeCalendarSelector(state),
    skipSearchFrontloadRequest: skipSearchFrontloadRequestSelector(state),
    promotionalBannerProduct: searchPromotionalBannerProductSelector(state),
    pageTitle,
    productAggPageContent: productAggPageContentSelector(state),
  };
};

const frontload = async (props: Props) => {
  const { sortBy, page, perPage, filtersStr, skipSearchFrontloadRequest } = props;
  if (skipSearchFrontloadRequest) return props.resetSkipSearchFrontloadRequest();
  if (!sortBy && !page && !perPage && !filtersStr) return; // Prevent browser back button click unexpected fetchSearchContent
  return props.fetchCalendarSearchContent();
};

const options = {
  onUpdate: true,
  _experimental_updateFunc: (prevProps: Props, newProps: Props) =>
    prevProps.sortBy !== newProps.sortBy ||
    prevProps.page !== newProps.page ||
    prevProps.perPage !== newProps.perPage ||
    prevProps.filtersStr !== newProps.filtersStr ||
    prevProps.isAuth !== newProps.isAuth,
};

export const PageProductCalendarContainer = connect(
  mapStateToProps,
  mapActionCreators
)(frontloadConnect(frontload, options)(PageProductCalendar));
